import { get, post } from '@/api/request';

const URI = "/dept"

// 部门管理-部门列表
export const listDept = params => get(`${URI}/list`, params);
// 部门管理-部门选择
// ?type=USER 加上后将不显示一级菜单
export const selectDept = (params) => get(`${URI}/select`, params);
// 部门管理-保存修改部门
export const saveOrUpdateDept = params => post(`${URI}/saveOrUpdate`, params);
// 部门管理-获取部门信息
export const getDept = id => get(`${URI}/info/${id}`);
// 部门管理-删除部门
export const delDept = id => get(`${URI}/delete/${id}`);



// WEBPACK FOOTER //
// ./src/api/system/dept.js